import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
//import * as moment from  'moment';
import moment from 'moment';
import { IStore } from 'src/app/store/services/store.service';
import { IReservationSectionPackage } from 'src/app/shared/services/reservation.service';
import { IReservationCheckoutTotalOptions } from '../../components/reservation-checkout-total/reservation-checkout-total.component';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'reservation-cart-modal',
    templateUrl: './reservation-cart-modal.component.html',
    styleUrls: ['./reservation-cart-modal.component.scss'],
    standalone: false
})
export class ReservationCartModalComponent implements OnInit {
  @Input() reservationSectionPackages: IReservationSectionPackage[];
  @Input() store: IStore;
  @Input() date: Date;

  get subTotal(): number {
    let subTotal = 0;
    this.reservationSectionPackages.forEach(p => {
      if(p){
        subTotal += p.Price * p.Quantity;
      }
    });
    return subTotal;
  }

  get totalOptions(): IReservationCheckoutTotalOptions {
    return {
      subTotal: this.subTotal,
      taxes: this.store.provinceTaxes,
      convenienceFee : this.store.convenienceFee,
      tip: 0
    };
  }

  get readyTime(): string {
    return moment(this.date).format('hh:mm A');
  }
  
  constructor(
    private modalCtrl: ModalController,
    //public translateService: TranslateService
    private translationService: TranslationService
    ) { }

  ngOnInit() { 

  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }

  async submit(){
    await this.modalCtrl.dismiss(true);        
  } 
  
  getPackageName(item: any)
  { 
    if(item){
      if(item.ItemName.Translations)
      {
          return item.ItemName.Translations[this.translationService.getLanguage()]
      }
      else
      {
        return item.ItemName
      }
    }
  }
}
